export const RELOCATION_OPTIONS = {
    ANYWHERE: 2, 
    SPECIFIC_LOCATIONS: 3,
    NOT_WILLING: 1,
}